import { useFormContext, useWatch } from "react-hook-form";
import { Table } from "stories";
import { currencyStyle } from "utils/customHooks/currencyFormat";
import { generateTitle } from "../../../assetBreakdown/elements/Summery";

const headers = [
  {
    id: "title",
    title: "Operating Revenue",
  },
  {
    id: "price_psf",
    title: "Lease PSF",
    align: "right",
  },
  {
    id: "total_price",
    title: "Annual Revenue",
    align: "right",
  },
];
export const OperatingRevenueTable = () => {
  const form = useFormContext();
  const [assets, parking, storage, totalRevenue] = useWatch({
    name: [
      "revenues.assets",
      "revenues.parking_assets",
      "revenues.storage_assets",
      "total_revenue",
    ],
    control: form.control,
  });
  let assetsArr = { ...assets };
  assetsArr = Object.keys(assetsArr).map((key) => ({
    uid: key,
    title: generateTitle(key),
    price_psf: `$ ${currencyStyle(assetsArr[key].price_psf)}`,
    total_price: `$ ${currencyStyle(assetsArr[key].total_price)}`,
    props: {
      title: {
        className: "capitalize",
      },
    },
  }));
  if (parking) {
    assetsArr.push({
      uid: "parking",
      title: "Parking",
      price_psf: `$ ${currencyStyle(parking.price_psf)}`,
      total_price: `$ ${currencyStyle(parking.total_price)}`,
    });
  }
  if (storage) {
    assetsArr.push({
      uid: "storage",
      title: "Storage",
      price_psf: `$ ${currencyStyle(storage.price_psf)}`,
      total_price: `$ ${currencyStyle(storage.total_price)}`,
    });
  }
  const assetsFooter = [
    {
      uid: "assets-footer",
      title: "Total Lease Value",
      price_psf: "",
      total_price: `$ ${currencyStyle(totalRevenue)}`,
      props: {
        title: {
          colSpan: 2,
        },
      },
    },
  ];

  return (
    <div className="pr-2/5">
      <Table
        sameColumnWidth
        headers={headers}
        rows={assetsArr}
        footer={assetsFooter}
      />
    </div>
  );
};
